module.exports = __webpack_public_path__ + "WoodBg2-a7c3e68b2b4f300ac4ab8a1614caf87b.png";